import { render, staticRenderFns } from "./Programa-ins.vue?vue&type=template&id=9e7e9a1e"
import script from "./Programa-ins.vue?vue&type=script&lang=js"
export * from "./Programa-ins.vue?vue&type=script&lang=js"
import style0 from "./Programa-ins.vue?vue&type=style&index=0&id=9e7e9a1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports